import { ablyChannelNamesForSession } from "_shared/_stores/realtime/ably-channel-names";
import reduxAblyMiddleware, { withCallbacks } from "_shared/_stores/realtime/redux-ably-middleware";
import Guid from "_shared/guids/guid";
import { MessageJSON } from "messaging/_schemas/message-schema";
import { addMessage, removeMessage } from "messaging/_stores/messages-redux-slice";
import Message from "messaging/message";

const toMessage = (payload: unknown) =>
  Message.fromJSON({
    json: payload as MessageJSON,
  });

const callbacks = withCallbacks()
  .add("message-received", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    dispatch(addMessage(message));
  })
  // Edits and soft deletes both replace the row in place. A delete payload is already a body-free
  // Message tombstone, so upserting it gives realtime readers the same projection as a cold refresh.
  .add("message-updated", (payload: unknown) => (dispatch) => {
    const message = toMessage(payload);
    dispatch(addMessage(message));
  })
  .add("message-deleted", (payload: unknown) => (dispatch) => {
    const id = new Guid((payload as { id: string }).id);
    dispatch(removeMessage(id));
  });

export const messagesAblyReduxMiddleware = reduxAblyMiddleware({
  callbacks,
  channelName: ablyChannelNamesForSession.messages,
  connectionHealth: { key: "messaging", label: "Messaging" },
  shouldConnectionStartImmediately: true,
});
